'use client';

import { useState } from 'react';
import styles from './ArticleShare.module.scss';
import { IconBrandLinkedin, IconBrandTwitter, IconCheck, IconLink } from '@tabler/icons-react';
import { Button, Text } from '@mantine/core';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';

export function ArticleShare({
  url,
  title,
  prominent = false,
}: {
  url: string;
  title: string;
  prominent?: boolean;
}) {
  const dict = useDictionary();
  const t = dict.articles;
  const [copied, setCopied] = useState(false);

  const shareLinkedIn = () => {
    const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    window.open(shareUrl, '_blank', 'width=600,height=600');
  };

  const shareTwitter = () => {
    const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
    window.open(shareUrl, '_blank', 'width=600,height=600');
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  };

  return (
    <div className={`${styles.share} ${prominent ? styles.prominent : ''}`}>
      <Text size={prominent ? 'md' : 'sm'} fw={700} className={styles.label}>
        {t.shareLabel}
      </Text>
      <div className={styles.actions}>
        <Button
          variant="light"
          size="sm"
          leftSection={<IconBrandLinkedin size={18} />}
          onClick={shareLinkedIn}
          className={styles.linkedin}
        >
          {t.shareLinkedIn}
        </Button>
        <Button
          variant="light"
          size="sm"
          leftSection={<IconBrandTwitter size={18} />}
          onClick={shareTwitter}
          className={styles.twitter}
        >
          {t.shareTwitter}
        </Button>
        <Button
          variant="light"
          size="sm"
          leftSection={copied ? <IconCheck size={18} /> : <IconLink size={18} />}
          onClick={copyLink}
          className={copied ? styles.copied : styles.copy}
        >
          {copied ? t.copied : t.copyLink}
        </Button>
      </div>
    </div>
  );
}
